import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { capi, apiError } from "@/lib/api";
import { AuthCard, FieldLabel, Notice, inputCls, btnCls } from "@/components/account/AuthCard";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await capi.post("/account/forgot-password", { email, origin: window.location.origin });
      setDone(true);
    } catch (e2) { setErr(apiError(e2)); }
    finally { setBusy(false); }
  };

  return (
    <AuthCard title="Reset password" subtitle="We'll email you a link to choose a new password." testid="forgot-password-page">
      {done ? (
        <Notice kind="info" testid="forgot-success">If that email has an account, a reset link has been sent. It expires in 1 hour.</Notice>
      ) : (
        <form onSubmit={submit}>
          {err && <Notice>{err}</Notice>}
          <FieldLabel>Email</FieldLabel>
          <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${inputCls} mb-5`} />
          <button data-testid="forgot-submit" disabled={busy} className={btnCls}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}</button>
        </form>
      )}
      <Link to="/account/login" className="mt-6 inline-flex text-sm font-semibold text-kys-accent hover:underline">← Back to sign in</Link>
    </AuthCard>
  );
}
